import { render, staticRenderFns } from "./PubNetPlane.vue?vue&type=template&id=0554c17a&scoped=true&"
import script from "./PubNetPlane.vue?vue&type=script&lang=js&"
export * from "./PubNetPlane.vue?vue&type=script&lang=js&"
import style0 from "./PubNetPlane.vue?vue&type=style&index=0&id=0554c17a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0554c17a",
  null
  
)

export default component.exports